import { NoteContent } from "../../../Components/NotesApp/NoteAppInterface";
export const Area51NoteContent: NoteContent[] = [
  {
    title: "Leila",
    date: "6 Sep 2024",
    content: [
      {
        entry:
          "Leila, I was in a dark place when I met you and you have brought me so much joy. You’ve taught me so much about myself that I never could’ve dreamed of. You saved me, you really did. I love you very much but I have to let you go. I am going through a lot in my work life at the moment and I can’t handle it all at once. I’m so sorry it has to be like this. I wish there was a way we could be together but it feels impossible to me. I wish I’d met you sooner. I’ll miss you so much. Everything about you, from your lips to our movie nights and your wonderful and beautiful mind. I’m going to ask to transfer you to another lab, to make this easier for the both of us. Please respect my decision and don’t try to change my mind. Love and kisses.",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "Panama City",
    date: "19 Aug 2024",
    content: [
      {
        entry:
          "from LV airport. Maristone $101 per night for 3 nights Sat - Mon.",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "Bossanova",
    date: "4 Aug 2024",
    content: [
      {
        entry: "Brazilian fusion restaurant",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "71 Rosewood Drive",
    date: "7 Jul 2024",
    content: [
      {
        entry: "71 Rosewood Drive",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "edible wrappers",
    date: "22 Jun 2024",
    content: [
      {
        entry: "edible wrappers",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "V153X12",
    date: "16 May 2024",
    content: [
      {
        entry: "number plate",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "Snacks",
    date: "6 Apr 2024",
    content: [
      {
        entry: "Cheetos, salted popcorn, coca-cola",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "Lab Tour",
    date: "19 Mar 2024",
    content: [
      {
        entry:
          "lab tour tomorrow - lab coat is in boot of car. my ID code: AA-153-0018",
      },
    ],
    locked: false,
    unclickable: false,
  },
  {
    title: "Rosa's Flowers",
    date: "18 Feb 2024",
    content: [
      {
        entry: "Rosa's Flowers",
      },
    ],
    locked: false,
    unclickable: false,
  },
];
